<template>
  <li
    class="sidebar__submenu"
    :class="{ 'sidebar__submenu--active': openSubmenu }"
    v-on-clickaway="away"
  >
    <div class="sidebar__submenu-title" @click="toggleDropdown">
      <slot name="title"></slot>
      <i class="fa fa-angle-right" aria-hidden="true"></i>
    </div>
    <div class="sidebar__submenu-content">
      <slot name="content"></slot>
    </div>
  </li>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";

export default {
  mixins: [clickaway],
  data() {
    return {
      openSubmenu: false,
    };
  },
  methods: {
    toggleDropdown() {
      // if (document.body.clientWidth < 769) {
      this.openSubmenu = !this.openSubmenu;
      // } else {
      // this.openSubmenu = false;
      // }
    },
    away() {
      if (this.openSubmenu) {
        this.openSubmenu = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/menu/Submenu.vue